import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
export default function FooterBrandLink() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="sr-only"><Link href="/" prefetch={false}>팬더티비 홈</Link></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}